// ========== ESCENARIO: LAZY MAPA + LÓGICA DE TRANSPORTE ==========
// Extraído de sections/escenario.liquid (blocks 224-296 y 318-556)

// --- Lazy load de Google Maps ---
let googleMapsLoaded = false;

function loadGoogleMaps() {
  if (googleMapsLoaded) return Promise.resolve();
  googleMapsLoaded = true;
  const placeholder = document.getElementById('map-placeholder');
  if (placeholder) placeholder.style.display = 'flex';
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAmNRRD-P18xdN_0WML6umXoiL745cwXBc&libraries=places,marker&loading=async&callback=initMap';
    script.async = true;
    script.defer = true;
    script.onload = () => {
      if (placeholder) placeholder.style.display = 'none';
      resolve();
    };
    script.onerror = () => {
      if (placeholder) placeholder.innerHTML = '<p style="color: #e74c3c;">Error al cargar el mapa. Inténtalo de nuevo.</p>';
      reject(new Error('Failed to load Google Maps'));
    };
    document.head.appendChild(script);
  });
}

function initMapLazyLoad() {
  const mapContainer = document.getElementById('map-container');
  const openMapBtn = document.getElementById('openMap');
  const loadMap = () => {
    loadGoogleMaps().catch(err => console.error('Error cargando Google Maps:', err));
  };
  if (mapContainer) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          loadMap();
          observer.unobserve(mapContainer);
        }
      });
    }, { threshold: 0.1 });
    observer.observe(mapContainer);
  }
  if (openMapBtn) {
    openMapBtn.addEventListener('click', loadMap, { once: true });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMapLazyLoad);
} else {
  initMapLazyLoad();
}

// --- Estado global transporte confirmado ---
window.transportConfirmed = false;

// --- Funciones globales ---
window.actualizarLabelTerminosEscenario = function() {
  const termsText = document.getElementById('termsTextEscenario');
  termsText.innerHTML = 'Al hacer clic en <strong>Finalizar compra</strong>, aceptas los <a href="#" onclick="openTermsModalFromLink(event); return false;" class="terms-link">Términos y Condiciones</a>.';
  actualizarEstadoBotonFinalizarCompra();
};

window.openTermsModalFromLink = function(e) {
  if (e) e.preventDefault();
  if (window.pendingAction) return;
  if (window.openTermsModal) {
    window.openTermsModal();
  }
};

function getProductName(productType) {
  const names = {
    6: "Fiesta Dominicana",
    7: "Plaza Herencia Dominicana",
    8: "Travesía Experience",
    9: "Travesía Preferred",
    10: "Travesía Premium"
  };
  return names[productType] || "Tickets";
}

function actualizarLabelProducto() {
  const productType = window.ticketSelectedProductType || parseInt(sessionStorage.getItem('ticketSelectedProductType') || '0', 10);
  const ticketsLabel = document.getElementById('tickets-label');
  const visitorType = sessionStorage.getItem('visitorType');
  if (ticketsLabel) {
    let name = getProductName(productType);
    if (visitorType === 'resident') {
      name = name + " (residente)";
    }
    ticketsLabel.textContent = name + ":";
  }
}

function ocultarMapaParaPlazaFiesta() {
  const productType = window.ticketSelectedProductType || parseInt(sessionStorage.getItem('ticketSelectedProductType') || '0', 10);
  if (productType === 6 || productType === 7) {
    const contenedorMapa = document.getElementById('contenedorMapa');
    if (contenedorMapa) contenedorMapa.style.display = 'none';
    const contenedorPrincipal = document.querySelector('.contenedor-principal');
    if (contenedorPrincipal) contenedorPrincipal.style.display = 'none';
    document.querySelectorAll('.checkPassports').forEach(cb => {
      const container = cb.closest('.container-check-label');
      if (container) container.style.display = 'none';
    });
  }
}

function sincronizarResidenteDesdePaginaPrincipal() {
  const visitorType = sessionStorage.getItem('visitorType');
  const checkBoxResidente = document.getElementById('checkBoxResidente');
  if (checkBoxResidente) {
    checkBoxResidente.checked = (visitorType === 'resident');
  }
}

function actualizarLabelResidente() {
  const visitorType = sessionStorage.getItem('visitorType');
  const residenteInfo = document.getElementById('residente-info');
  const esResidente = visitorType === 'resident';
  if (residenteInfo) {
    residenteInfo.style.display = esResidente ? 'block' : 'none';
  }
}

function actualizarTransporteParaResidente() {
  const visitorType = sessionStorage.getItem('visitorType');
  const transportContainer = document.getElementById('transport-container');
  const transportInfoResidente = document.getElementById('transport-info-residente');
  const includesTransport = document.getElementById('includesTransport');
  const esResidente = visitorType === 'resident';
  if (transportContainer) transportContainer.style.display = esResidente ? 'none' : 'block';
  if (transportInfoResidente) transportInfoResidente.style.display = esResidente ? 'block' : 'none';
  if (includesTransport && esResidente) {
    includesTransport.checked = false;
  }
}

function actualizarTransporteSegunCantidad() {
  const visitorType = sessionStorage.getItem('visitorType');
  const includesTransport = document.getElementById('includesTransport');
  if (visitorType === 'resident' || !includesTransport) return;
  const qtyAdult = parseInt(document.getElementById('qty-cart')?.textContent || document.getElementById('qty-cart')?.value || '0', 10) || 0;
  const qtyChild = parseInt(document.getElementById('qty-cart-child')?.textContent || document.getElementById('qty-cart-child')?.value || '0', 10) || 0;
  const totalTickets = qtyAdult + qtyChild;
  if (totalTickets < 2) {
    if (includesTransport.checked) {
      includesTransport.checked = false;
      includesTransport.dispatchEvent(new Event('change', { bubbles: true }));
    }
    includesTransport.disabled = true;
  } else {
    includesTransport.disabled = false;
    if (typeof showSubTotalTransporte === 'function') {
      showSubTotalTransporte();
    }
  }
}

function confirmarTransporte() {
  window.transportConfirmed = true;
  actualizarLabelTerminosEscenario();
}

function resetearTransporte() {
  window.transportConfirmed = false;
  if (typeof window.resetTransportState === 'function') {
    window.resetTransportState();
  }
  actualizarLabelTerminosEscenario();
}

function actualizarEstadoBotonFinalizarCompra() {
  const getCarritoBtn = document.getElementById('getCarrito');
  const includesTransport = document.getElementById('includesTransport');
  const hasTransportSelected = includesTransport && includesTransport.checked;
  if (getCarritoBtn) {
    getCarritoBtn.disabled = hasTransportSelected && !window.transportConfirmed;
  }
}

document.addEventListener('DOMContentLoaded', function() {
  actualizarLabelTerminosEscenario();
  const observer = new MutationObserver(function(mutations) {
    const container = document.getElementById('container-compra-ahora');
    if (container && container.style.display === 'flex') {
      actualizarLabelProducto();
      ocultarMapaParaPlazaFiesta();
      sincronizarResidenteDesdePaginaPrincipal();
      actualizarTransporteParaResidente();
      actualizarLabelResidente();
      actualizarTransporteSegunCantidad();
      actualizarLabelTerminosEscenario();
      actualizarEstadoBotonFinalizarCompra();
    }
  });
  observer.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['style'] });
  actualizarLabelProducto();
  ocultarMapaParaPlazaFiesta();
  sincronizarResidenteDesdePaginaPrincipal();
  actualizarTransporteParaResidente();
  actualizarLabelResidente();
  actualizarTransporteSegunCantidad();
  actualizarEstadoBotonFinalizarCompra();
  const includesTransport = document.getElementById('includesTransport');
  if (includesTransport) {
    includesTransport.addEventListener('change', function() {
      if (!this.checked) {
        resetearTransporte();
      }
      actualizarEstadoBotonFinalizarCompra();
    });
  }
});
